import React from 'react';
import StepsContent from '../../components/stepsContent';
import ActionBar from '../../components/ActionBarPrimary';
import SmartHeader from '../../components/smartHeader';
import s from './index.module.scss';
import { useAppStore } from '../../store';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function Steps() {
  const showActionBar = useAppStore((state) => state.showActionBar);
  const currentStepCompleted = useAppStore((state) => state.currentStepCompleted);

  return (
    <div className={s.page}>
      <div className={s.contentWrapper}>
        <SmartHeader />
        <StepsContent />
        <ActionBar
          show={showActionBar}
          currentStepCompleted={currentStepCompleted}
          transparentBg={undefined}
          whiteStyle={undefined}
          withShadow={undefined}
        />
      </div>
    </div>
  );
}

export default Steps;
